import { Spinner } from '@components/core-ui/spinners/Spinner';
import { usePageContext } from '../../providers/PageProvider';
import { RegistrationPageFirstStage } from './stages/first';
import { RegistrationPageCodeStage } from './stages/signupCode';
import { RegistrationPagePhoneStage } from './stages/signupPhone';
import { RegistrationPageSurveyStage } from './stages/signupSurvey';
import { RegistrationPageSuccessStage } from './stages/success';
import { Wrapper } from './styles/Wrapper';

export const RegistrationPageContent = () => {
  const { stage, isLoading } = usePageContext();

  return (
    <>
      {isLoading && <Spinner overlay={true} />}
      <Wrapper>
        {stage === 'first' ? <RegistrationPageFirstStage /> : null}
        {stage === 'signupSurvey' ? <RegistrationPageSurveyStage /> : null}
        {stage === 'signupPhone' ? <RegistrationPagePhoneStage /> : null}
        {stage === 'signupCode' ? <RegistrationPageCodeStage /> : null}
        {stage === 'success' ? <RegistrationPageSuccessStage /> : null}
      </Wrapper>
    </>
  );
};
